const PROFILE_PAGE = '/profile';

function getUrl(urlOrURL) {
  if (urlOrURL instanceof window.URL) {
    return urlOrURL.href;
  }

  return urlOrURL;
}

async function sendData(data) {
  const url = '/wp-json/api/v1/club-membership-metadata';

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  if (!response.status === 200) {
    throw new Error('Response status was not 200');
  }
  const responseData = await response.json();
  return responseData;
}

function watchForCancelRequest() {
  const xmlHttpRequestPrototype = Object.getPrototypeOf(new window.XMLHttpRequest());
  const originalOpen = xmlHttpRequestPrototype.open;
  const originalSend = xmlHttpRequestPrototype.send;

  xmlHttpRequestPrototype.open = function() {
    this._url = getUrl(arguments[1]);
    this._method = arguments[0];
    return originalOpen.apply(this, arguments);
  };

  xmlHttpRequestPrototype.send = function() {
    const HOST_NAME = 'api.commerce7.com';
    const CANCEL_PATHNAME = /^\/(v1|v2)\/customer\/(?:[A-Za-z0-9\-]+)\/club-membership\/(?:[A-Za-z0-9\-]+)\/cancel\/?$/i;
    const url = new URL(this._url);

    if (
      url.hostname === HOST_NAME &&
      CANCEL_PATHNAME.test(url.pathname) &&
      arguments[0] &&
      this._method == 'PUT'
    ) {
      this.addEventListener('load', function() {
        if (this.readyState === 4 && this.status === 200) {
          updateClubMembershipMetadata(this.responseText);
        }
      });
    }
    return originalSend.apply(this, arguments);
  };
}

/**
 * Send data to the server and mark club membership metadata as cancelled by customer
 * @param {string} _data - club membership object stringified
 */

async function updateClubMembershipMetadata(_data) {
  try {
    const data = JSON.parse(_data);
    await sendData({ type: 'cancelled-by-customer', data });
  } catch (err) {
    console.error(err);
  }
}

function main() {
  const url = new URL(window.location);
  if (!url.pathname.startsWith(PROFILE_PAGE)) return;

  if (window._rmb_clubmemCancelWatched) return;
  window._rmb_clubmemCancelWatched = true;

  watchForCancelRequest();
}

export default main;
